import { media, tokens } from '@domain-group/fe-brary';
import { css } from '@emotion/react';

export const container = (hasBackground: boolean) => css`
  ${media('>=desktop')} {
    padding: ${hasBackground ? tokens.spacing.s : 0};
    background-color: ${hasBackground
      ? tokens.colors.neutral.surface.hover
      : 'inherit'};
  }
`;
